'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'skull-crossbones';
var width = 448;
var height = 512;
var aliases = [128369,9760];
var unicode = 'f714';
var svgPathData = 'M304.2 210.8c20.4-18 31.8-41.8 31.8-66.8 0-48.4-45.3-96-112-96S112 95.6 112 144c0 25.1 11.3 48.8 31.8 66.8 10.3 9.1 16.2 22.2 16.2 36l0 17.2c0 4.4 3.6 8 8 8l112 0c4.4 0 8-3.6 8-8l0-17.2c0-13.8 5.9-26.9 16.2-36zM336 264c0 30.9-25.1 56-56 56l-112 0c-30.9 0-56-25.1-56-56l0-17.2C82.4 220.7 64 184.3 64 144 64 64.5 135.6 0 224 0S384 64.5 384 144c0 40.3-18.4 76.7-48 102.8l0 17.2zM2 334.3c5.3-12.1 19.5-17.6 31.6-12.3L224 405.8 414.3 322c12.1-5.3 26.3 .2 31.6 12.3s-.2 26.3-12.3 31.6l-150.1 66 150.1 66c12.1 5.3 17.6 19.5 12.3 31.6s-19.5 17.6-31.6 12.3L224 458.2 33.7 542c-12.1 5.3-26.3-.2-31.6-12.3s.2-26.3 12.3-31.6l150.1-66-150.1-66C2.2 360.6-3.3 346.5 2 334.3zM144 144a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSkullCrossbones = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;